/**
 * Returns a function that is able to format TextField input (while typing) as a valid time string
 * (by adding colon on the right places and changing the input of hours/minutes to maximum values)
 * @param {boolean} is12HourFormat
 * @returns {Function}
 */
export default function getTimeFormatter(is12HourFormat = false, allowEmpty = false) {
    const maxHours = value => {
        const maxHoursTest = is12HourFormat ? 12 : 23
        const maxHoursReplace = is12HourFormat ? '12' : '00'
        return parseInt(value) > maxHoursTest ? maxHoursReplace : value
    }
    const maxMinutes = value => (parseInt(value) > 59 ? '00' : value)

    return function (value = '', finalize = false) {
        let formattedValue = value.replace(/\D/g, '')
        if ((value.length === 0 || value === ':') && finalize && !allowEmpty) {
            formattedValue = `${is12HourFormat ? '12' : '00'}:00`
        } else if (formattedValue.length < 3 && value.length > 0 && finalize) {
            formattedValue = `${maxHours(formattedValue)}:00`
        } else if (value.length < 4 && !finalize && value.includes(':')) {
            formattedValue = value.replace(/[^:0-9]/g, '').replace(/:+/g, ':')
        } else if (formattedValue.length === 3 && !finalize) {
            formattedValue = formattedValue.replace(/(\d)(\d\d)/, '$1:$2')
        } else if (formattedValue.length === 3 && finalize) {
            const match = formattedValue.match(/(\d)(\d\d)/)
            formattedValue = `${match[1]}:${maxMinutes(match[2])}`
        } else if (formattedValue.length === 4) {
            const match = formattedValue.match(/(\d\d)(\d\d)/)
            formattedValue = `${maxHours(match[1])}:${maxMinutes(match[2])}`
        }
        return formattedValue
    }
}
